Vue.component('app-chat', {
    mounted: function() {
        this.chatData.component = this;
    },
    props: ['chatData'],
    data: function() {
        return {
            chatData: null,
            settings: game.settings,
            newMessages: 0,
            lastMessageTime: 0,
            chatMessage: '',
            isClosing: false,
            isOpen: false,
            currentUser: null
        };
    },
    methods: {
        open: function() {
            if (this.isClosing) {
                this.isOpen = false;
                this.isClosing = false;
            } else {
                this.isOpen = true;
                this.newMessages = 0;

                setTimeout(() => {
                    let messagesElement = this.$el.querySelector("#chat-messages");
                    messagesElement.scrollTop = messagesElement.scrollHeight;
                }, 1);
            }
        },
        close: function() {
            this.isClosing = true;
        },
        addChatMessage: function(data) {
            if (data.message) {
                if (data.message.startsWith('http://antwar.io?invite=')) {
                    data.gameJoinToken = data.message.replace('http://antwar.io?invite=', '').trim();
                }
            }
            data.color = this.getChatColor(data);
            this.chatData.messages.push(data);

            let messagesElement = this.$el.querySelector("#chat-messages");
            if (messagesElement) {
                let isScrolledToBottom = messagesElement.scrollHeight - messagesElement.clientHeight <= messagesElement.scrollTop;
                if (isScrolledToBottom) {
                    setTimeout(() => {
                        messagesElement.scrollTop = messagesElement.scrollHeight;
                    }, 1);
                }
            }

            if (!this.isOpen && data.name) {
                this.newMessages++;
            }
        },
        sendChat: function() {
            if (!game.services.user.currentUser && !game.isPlayScreen) {
                this.addChatMessage({message: 'Must be logged in to chat.'});
                return;
            }

            let message = this.chatMessage;
            if (message && message.trim) {
                message = message.trim();
            }

            if (message && message.length >= 1 && message.length <= 250) {
                if (Date.now() - this.lastMessageTime > 600) {
                    if (game.isPlayScreen) {
                        game.mainSocket.emit('chat', {
                            channel: this.chatData.channel,
                            message: message
                        });
                    } else {
                        game.services.socket.getMenuSocket().emit('chat', message);
                    }
                } else {
                    this.addChatMessage({message: 'Please do not spam the chat.'});
                }
                this.lastMessageTime = Date.now();

                let messagesElement = this.$el.querySelector("#chat-messages");
                messagesElement.scrollTop = messagesElement.scrollHeight;
            }

            this.chatMessage = '';
            if (game.app && game.app.view) {
                game.app.view.focus();
            }
        },
        getChatColor: function(chatObject) {
            if (chatObject && chatObject.team !== null && chatObject.team !== undefined) {
                return game.getTeamHex(chatObject.team);
            } else if (chatObject.isDev) {
                return '#0c9c18';
            }
            return '#8d8d8d';
        }
    },
    template: `
    <div class="app-chat-handle" v-bind:class="{'app-chat-handle-clickable': !isOpen, 'app-chat-open': isOpen, 'message-flash': newMessages}" v-on:click="open()" v-show="!settings.disableChat">
        <div v-if="!isOpen">
            <span v-if="!currentUser">{{chatData.name ? chatData.name : 'Chat'}}</span>
            <span v-if="currentUser">{{currentUser.name}}</span>
            <span v-if="newMessages">({{newMessages >= 20 ? '20+' : newMessages}})</span>
        </div>
        <div v-if="isOpen">
            <div class="app-chat-title">
                <span v-if="!currentUser">{{chatData.name ? chatData.name : 'Chat'}}</span>
                <span v-if="currentUser">{{currentUser.name}}</span>
            </div>
            <div class="app-chat-close" v-on:click="close()">
                <i class="fa fa-close"></i>
            </div>
            <div id="chat-messages" class="app-chat-messages">
                <div v-for="chat in chatData.messages">
                    <div class="chat-message" v-bind:class="{'chat-message-server':!chat.name}">
                        <span v-if="!!chat.name">
                            <span v-if="chat.isDev">
                                <div class="chat-rank-dev"></div>
                            </span>
                            <span v-if="!chat.isDev && chat.xp">
                                <div class="chat-rank"><img class="icon-xs" src="assets/rank_icon.png"> <b>{{game.calculateRank(chat.xp)}}</b></div>
                            </span>
                            <div class="chat-message-name" v-bind:class="{'chat-message-name-dev':chat.isDev}" v-bind:title="'User ID: ' + chat.userId" v-bind:style="{color:chat.color}">
                                {{chat.name}}:
                            </div>
                        </span>
                        <span v-if="!chat.gameJoinToken">
                            {{chat.message}}
                        </span>
                        <div v-if="chat.gameJoinToken">
                            <a v-bind:href="'http://antwar.io?invite=' + chat.gameJoinToken" style="font-size:18px; padding:8px; text-align:center;" class="app-btn app-btn-primary"><i class="fa fa-play"></i> Join {{chat.name}}'s Game</a>
                        </div>
                    </div>
                </div>
            </div>
            <input type="text" @keyup.enter="sendChat" v-model="chatMessage">
        </div>
    </div>
    `
})